import BottomPanel from "src/components/controls/bottom-panel";

import { useAppStore } from "@/store/appStore";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Image from "@/components/image";
import Text from "@/components/text/text";
import Joystick from "../controls/exploration/joystick";
import { useModelViewerStore } from "@/store/modelViewerStore";
import ModelViewerSideControl from "@/components/controls/modelViewer/modelViewer-side-control";
import { CHAT_TYPE } from "@/types/navigation-mode";
import TopViewButton from "../button/top-view-button";
import ModelViewerPanel from "@/components/controls/modelViewer/modelViewer-panel";

const ModelViewerWithCustomPathLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const setChatType = useAppStore((state) => state.setChatType);
  const interruptAutoPlay = useModelViewerStore(
    (state) => state.interruptAutoPlay,
  );
  const setProgress = useModelViewerStore((state) => state.setProgress);

  const setPositionJoystickData = useModelViewerStore(
    (state) => state.setPositionJoystickData,
  );
  const setRotationJoystickData = useModelViewerStore(
    (state) => state.setRotationJoystickData,
  );

  const handlePositionJoystickMove = (x: number, y: number) => {
    setPositionJoystickData([x, y]);
  };

  const handlePositionJoystickRelease = () => {
    setPositionJoystickData([0, 0]);
  };

  const handleRotationJoystickMove = (x: number, y: number) => {
    setRotationJoystickData([x, y]);
  };

  const handleRotationJoystickRelease = () => {
    setRotationJoystickData([0, 0]);
  };

  useEffect(() => {
    setChatType(CHAT_TYPE.MODELVIEWER);
  }, []);

  const Joysticks = () => {
    return (
      <div className="absolute bottom-0 left-0 right-0">
        <div className="flex fixed justify-between bottom-0 w-full px-[20px] mb-[20px]">
          <Joystick
            onMove={handlePositionJoystickMove}
            onRelease={handlePositionJoystickRelease}
            topChild={
              <Image
                src="/assets/icon_joystick_up.png"
                height={24}
                width={24}
              />
            }
            bottomChild={
              <Image
                src="/assets/icon_joystick_down.png"
                height={24}
                width={24}
              />
            }
            leftChild={
              <Image
                src="/assets/icon_joystick_left.png"
                height={24}
                width={24}
              />
            }
            rightChild={
              <Image
                src="/assets/icon_joystick_right.png"
                height={24}
                width={24}
              />
            }
          />
          <Joystick
            onMove={handleRotationJoystickMove}
            onRelease={handleRotationJoystickRelease}
            topChild={<Text text="joystick_up" size={10} />}
            bottomChild={<Text text="joystick_down" size={10} />}
            leftChild={
              <Image
                src="/assets/icon_joystick_rotate_left.png"
                height={20}
                width={20}
              />
            }
            rightChild={
              <Image
                src="/assets/icon_joystick_rotate_right.png"
                height={20}
                width={20}
              />
            }
          />
        </div>
      </div>
    );
  };

  return (
    <div className="fullscreen_div">
      {children}
      {/*<Joysticks />*/}
      <div className="absolute bottom-0 left-0 right-0">
        <ModelViewerPanel/>
      </div>
      <div className="absolute bottom-[184px] md:bottom-40 right-0">
        <ModelViewerSideControl />
      </div>
      <div className="absolute bottom-[184px] md:bottom-[20%] left-0 m-6 mb-[20px] md:mb-[35px]">
        {/*<TopViewButton />*/}
      </div>
    </div>
  );
};

export default ModelViewerWithCustomPathLayout;
